export const weather_en = {
    "sunny": "Sunny",
    "halfsunny": "Some clouds",
    "cloudy": "Very cloudy",
    "foggy": "Foggy",
    "cloud": "Cloudy",
    "sleet": "Sleet",
    "snowing": "Snow",
    "rain": "Rain",
    "storm": "Thunderstorm",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Unknown",
    "unknown_weather": "Unknown",
}

export const weather_de = {
    "sunny": "Sonnig",
    "halfsunny": "Einige Wolken",
    "cloudy": "Stark bewölkt",
    "foggy": "Nebelig",
    "cloud": "Bewölkt",
    "sleet": "Schneeregen",
    "snowing": "Schneefälle",
    "rain": "Regen",
    "storm": "Gewitter",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Unbekannt",
    "unknown_weather": "Unbekannt",
}

export const weather_fr = {
    "sunny": "Ensoleillé",
    "halfsunny": "Peu nuageux",
    "cloudy": "Très nuageux",
    "foggy": "Brumeux",
    "cloud": "Nuageux",
    "sleet": "Neige fondue",
    "snowing": "Chutes de neige",
    "rain": "Pluie",
    "storm": "Tempête",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Inconnu",
    "unknown_weather": "Inconnu",
}

export const weather_it = {
    "sunny": "Soleggiato",
    "halfsunny": "Leggermente nuvoloso",
    "cloudy": "Molto nuvoloso",
    "foggy": "Nebbioso",
    "cloud": "Nuvoloso",
    "sleet": "Nevischio",
    "snowing": "Neve",
    "rain": "Pioggia",
    "storm": "Temporale",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Sconosciuto",
    "unknown_weather": "Sconosciuto",
}

export const weather_es = {
    "sunny": "Soleado",
    "halfsunny": "Poco nuboso",
    "cloudy": "Muy nuboso",
    "foggy": "Brumoso",
    "cloud": "Nuboso",
    "sleet": "Aguanieve",
    "snowing": "Nevadas",
    "rain": "Lluvia",
    "storm": "Tormenta",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Desconocido",
    "unknown_weather": "Desconocido",
}

export const weather_nb = {
    "sunny": "Solfylt",
    "halfsunny": "Noen skyer",
    "cloudy": "Tett skydekke",
    "foggy": "Tåkete",
    "cloud": "Overskyet",
    "sleet": "Sludd",
    "snowing": "Snø",
    "rain": "Regn",
    "storm": "Tordenvær",
    "nightpartcloud": "Night partly cloudy",
    "nightclear": "Night clear",
    "unknown": "Ukjent",
    "unknown_weather": "Ukjent",
}